import React from 'react'
import ApplicantForgotPassword from '../../components/applicantcomponents/ApplicantForgotPassword';
import TestFooter from '../../components/common/TestFooter';
function RecruiterForgotPasswordPage() {
  return (
    <div>
     {/* <Nav /> */}
    <ApplicantForgotPassword />
    <TestFooter />
    </div>
  )
}
export default RecruiterForgotPasswordPage;